// EnableDisableButtons.js
import React from 'react';
import { Button } from 'react-bootstrap';

const EnableDisableButtons = ({ onEnableAll, onDisableAll, t }) => {
    return (
        <div>
            <Button variant="success" style={{ marginLeft: '10px' }} onClick={onEnableAll}>
                {t('Enable All Alerts')}
            </Button>
            <Button variant="danger" style={{ marginLeft: '10px' }} onClick={onDisableAll}>
                {t('Disable All Alerts')}
            </Button>
        </div>
    );
};

export default EnableDisableButtons;
